import React from 'react';
import { Typography, Box, Avatar } from '@mui/material';
import { Circle as CircleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

/** Someone you are connected with mentioned you in a post (interact/post/mentions.py). */
export default function MentionNotificationCard({ notification, onMarkRead }) {
  const navigate = useNavigate();
  const p = notification.payload || {};
  const open = () => {
    if (!notification.is_read && onMarkRead) onMarkRead();
    if (p.url) navigate(p.url);
  };
  return (
    <Box onClick={open} sx={{
      display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1.25, px: 2, borderBottom: '1px solid', borderColor: 'divider',
      backgroundColor: notification.is_read ? 'transparent' : 'action.hover', cursor: 'pointer', '&:hover': { backgroundColor: 'action.selected' },
    }}>
      <Avatar src={p.author_avatar || undefined} sx={{ width: 34, height: 34, mt: 0.25, bgcolor: 'primary.avatar', color: '#fff' }}>
        {(p.author_name || '@')[0]}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2">
          <Box component="span" fontWeight={600}>{p.author_name || 'Someone'}</Box>
          <Box component="span" color="text.secondary"> mentioned you in {({ reply: 'a reply', interest: 'an interest' })[p.where] || 'a post'}</Box>
        </Typography>
        {p.excerpt && (
          <Typography variant="caption" color="text.secondary" sx={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
            {p.excerpt}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          {formatDistanceToNow(new Date(notification.created), { addSuffix: true })}
        </Typography>
        {!notification.is_read && <CircleIcon sx={{ fontSize: 8, color: 'primary.main' }} />}
      </Box>
    </Box>
  );
}
